import store from '@/store';

export default (to, from, next) => ({
    allow: store.getters.is_account_postpay,
    redirect: { name: 'not-found' },
});